export default "__VITE_ASSET__a21d7102__"